import { EngagementStatus, EngagementStatusValue } from '../../types/advise';

export const ENGAGEMENT_STATUS_LABELS: Record<EngagementStatusValue, string> = {
  [EngagementStatus.DRAFT]: 'Draft',
  [EngagementStatus.IN_PROGRESS]: 'In Progress',
  [EngagementStatus.PUBLISHED]: 'Published',
  [EngagementStatus.IN_REVIEW]: 'In Review'
};

export const engagementStatusLabel = (status: string | null | undefined): string =>
  ENGAGEMENT_STATUS_LABELS[status as EngagementStatusValue] || status || '';
